import React from "react";
import Highlight from "react-highlighter";

import clsx from "clsx";

import styles from "../TermDictionary.module.scss";

export interface ITermDictionaryGridItemProps {
  term: string;
  definition: string;
  keyword?: string;
}

export const TermDictionaryGridItem: React.FC<ITermDictionaryGridItemProps> = ({ term, definition, keyword }) => {
  return (
    <>
      <div className={clsx(styles.term, styles.wrapText)}>
        <Highlight search={keyword || ""}>{term}</Highlight>
      </div>
      <div className={clsx(styles.translation, styles.wrapText)}>
        <Highlight search={keyword || ""}>{definition}</Highlight>
      </div>
    </>
  );
};
